import React from "react"
import { useRemarkSync } from "react-remark"
import rehypeSanitize from "rehype-sanitize"
import rehypeExternalLinks from "rehype-external-links"

/**
 * Minimal markdown for the hover-card bio. Kept as a leaf here (react-remark directly) rather than importing
 * @love-irish/core-content: core-content now renders `/@username` mentions through UserPopover, so importing
 * it back here would create a core-content <-> user-popover cycle. A bio is short, so it needs no dropcap /
 * front-matter handling — just sanitized markdown with safe external links.
 */
export const BioContent: React.FC<{ content: string; className?: string }> = ({
  content,
  className,
}) => {
  const rendered = useRemarkSync(content, {
    rehypePlugins: [
      rehypeSanitize,
      [rehypeExternalLinks, { rel: ["ugc", "noopener"], target: "_blank" }],
    ],
  })

  return <div className={className}>{rendered}</div>
}

export default BioContent
